import axios from 'axios';

const state = {
    areas: [],
    areaLists: [],
    rows: 1,
    perPage: 10,
    meta: {},
};

const getters = {
    areas: state =>{
        return state.areas;
    },
    areaLists: state =>{
        return state.areaLists;
    },
    rows: state => {
        return state.rows;
    },
    perPage: state => {
        return state.perPage;
    },
    meta: state => {
        return state.meta;
    },
};

const actions = {
    getAreas({commit, dispatch}, filter){
        dispatch('Settings/loading', true,{root:true});
        try {
            axios
                .get(`/admin/areas?page=${filter.currentPage}&sortBy=${filter.sortBy}&sortOrder=${filter.sortOrder}`)
                .then((res) => {

                    commit('setAreas', res.data.data);
                    commit('setRows', Math.ceil(
                        res.data.meta.total / res.data.meta.per_page
                    ))
                    commit('setPerPage', parseInt(res.data.meta.per_page))
                    commit('SET_META', res.data.meta)
                    dispatch('Settings/loading', false, { root: true });
                })
                .catch((err) => {
                    console.log(err);
                    dispatch('Settings/loading', false,{root:true});
                });
        } catch (err) {
            console.log(err);
            dispatch('Settings/loading', false,{root:true});
        }

    },
    getAreaLists({commit, dispatch}, currentPage){
        dispatch('Settings/loading', true,{root:true});
        try {
            axios
                .get(`/admin/areas/lists?page=${currentPage  ? currentPage : '1'}`)
                .then((res) => {

                    commit('setAreaLists', res.data.data);
                    dispatch('Settings/loading', false, { root: true });
                })
                .catch((err) => {
                    console.log(err);
                    dispatch('Settings/loading', false,{root:true});
                });
        } catch (err) {
            console.log(err);
            dispatch('Settings/loading', false,{root:true});
        }

    },
    storeArea({commit}, payload){
        return axios
            .post(`/admin/areas`, payload)
            .then((res) => {
                commit('updateAreasList', res.data.data);
            });
    },

    updateArea({commit}, user){
        return axios
            .put(`/admin/areas/${user.id}`, user)
            .then((res) => {
                commit('updateEditedArea', res.data.data);
            });
    },
    destroy({ commit }, id) {
        return axios.delete(`/admin/areas/${id}`).then((res) => {
            commit("DELETE_NOTICE", id);
            return res;
        });
    },
};

const mutations = {
    setAreas(state, areas){
        state.areas = areas;
    },
    setAreaLists(state, areas){
        state.areaLists = areas;
    },
    updateAreasList(state, user){
        state.areas.unshift(user);
    },
    updateEditedArea(state, user){
        state.areas.map((item,index)=>{
            if(item.id == user.id){
                state.areas[index] = user;
            }
        });
    },
    DELETE_NOTICE(state, id) {
        const i = state.areas.map((item) => item.id).indexOf(id);
        state.areas.splice(i, 1);
    },
    setRows(state, rows) {
        state.rows = rows;
    },
    setPerPage(state, perPage) {
        state.perPage = perPage;
    },
    SET_META(state, meta) {
        state.meta = meta;
    },
};

export default {
    namespaced:true,
    state,
    getters,
    actions,
    mutations
}
